
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[language]/help/[...category]",
      function () {
        return require("private-next-pages/[language]/help/[...category].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[language]/help/[...category]"])
      });
    }
  